module.exports = __webpack_public_path__ + "static/media/startup-smart-header.579b9548.jpg";